import type { CSSProperties } from 'react';
import './ThinkingCube.css';

const faces = ['front', 'back', 'right', 'left', 'top', 'bottom'];

/** CSS 3D cubies with independently turning horizontal layers. */
export function ThinkingCube() {
  return (
    <div className="lab-thinking-scene" aria-hidden="true">
      <div className="lab-thinking-cube">
        {[-1, 0, 1].map(y => (
          <div key={y} className={`lab-thinking-layer lab-thinking-layer-${y + 1}`}
            style={{ '--layer-y': `${y * 29}px` } as CSSProperties}>
            {[-1, 0, 1].flatMap(x => [-1, 0, 1].map(z => (
              <div key={`${x}:${z}`} className="lab-thinking-cubie"
                style={{ transform: `translate3d(${x * 29}px, 0, ${z * 29}px)` }}>
                {faces.map(face => <span key={face} className={`lab-thinking-face lab-thinking-face-${face}`} />)}
              </div>
            )))}
          </div>
        ))}
      </div>
    </div>
  );
}
